import { haversineMeters } from './anfahrt';

/**
 * Routen über die Place-ID statt über die Koordinate (Konzept Phase 2e,
 * nextcab_mobile/docs/general/mietwagen_festpreis_modus_konzept.md).
 *
 * Google routet ab einer Place-ID vom Zugangspunkt auf der Straße. Ab einer
 * ROOFTOP-Koordinate fängt die Route dagegen oft in der Zufahrt, und es
 * entsteht ein Wendeumweg (Lieth 2D: 6,49 statt 2,37 km). Die Regeln
 * spiegeln die Fahrer-App (RoutesService, home_driver.dart), damit LiveMap
 * und Fahrtdetails dieselbe Strecke zeigen wie Fahrer und Festpreis.
 */

/** Zugangspunkt weiter weg von der Koordinate → Place-ID passt nicht (RoutesService.placeIdMaxAbstandM). */
export const PLACE_ID_MAX_ABSTAND_M = 150;
/** Anfahrt per Place-ID erst ab diesem Abstand Fahrer → Abholort (sonst Schleife aus der Zufahrt). */
export const ANFAHRT_PLACE_ID_MIN_ABSTAND_M = 300;
/** Fahrtbeginn ab der Place-ID des Abholorts, wenn der Fahrer höchstens so weit davon steht. */
export const FAHRTBEGINN_PLACE_ID_MAX_ABSTAND_M = 50;

const validPlaceId = (id) => (typeof id === 'string' && id.trim() ? id.trim() : null);

/** Punkt { lat, lng } mit optionaler Place-ID. */
export const routePoint = (position, placeId = null) => (
  position ? { lat: position.lat, lng: position.lng, placeId: validPlaceId(placeId) } : null
);

export const withoutPlaceId = (point) => (point ? { ...point, placeId: null } : null);

/** Abholort als Ziel der Anfahrt: Place-ID nur, wenn der Fahrer weit genug weg ist. */
export const anfahrtPickupPoint = (pickup, placeId, driverPosition) => {
  const point = routePoint(pickup, placeId);
  if (!point?.placeId || !driverPosition) return point;
  return haversineMeters(driverPosition, pickup) >= ANFAHRT_PLACE_ID_MIN_ABSTAND_M ? point : withoutPlaceId(point);
};

/** Start der Zielfahrt: Steht der Fahrer am Abholort, ab dessen Place-ID, sonst ab seinem GPS. */
export const fahrtbeginnOrigin = (driverPosition, pickup, pickupPlaceId) => {
  const placeId = validPlaceId(pickupPlaceId);
  if (placeId && driverPosition && pickup &&
      haversineMeters(driverPosition, pickup) <= FAHRTBEGINN_PLACE_ID_MAX_ABSTAND_M) {
    return routePoint(pickup, placeId);
  }
  return routePoint(driverPosition);
};

/** Wegpunkt für die Routes API (computeRoutes). */
export const routesApiWaypoint = (point) => (
  point.placeId
    ? { placeId: point.placeId }
    : { location: { latLng: { latitude: point.lat, longitude: point.lng } } }
);

/** Ort für den DirectionsService (Maps JS). */
export const directionsLocation = (point) => (point.placeId ? { placeId: point.placeId } : { lat: point.lat, lng: point.lng });

export const hasPlaceIds = (points) => points.some((p) => p?.placeId);

/**
 * Passt die Route zu den Koordinaten? `points` = [Start, …Halte, Ziel],
 * `legEnds` = je Etappe { start: {lat,lng}, end: {lat,lng} }. Nur Punkte mit
 * Place-ID werden geprüft; fehlt ein Endpunkt, gilt das als nicht bestanden.
 */
export const placeIdsPlausibel = (points, legEnds) => points.every((point, index) => {
  if (!point?.placeId) return true;
  const ist = index === 0 ? legEnds[0]?.start : legEnds[index - 1]?.end;
  return !!ist && haversineMeters(point, ist) <= PLACE_ID_MAX_ABSTAND_M;
});
